import { LegalPage } from "@/components/LegalPage";

const INTRO = [
  "Welcome to SYNAPHY (\u201cSYNAPHY\u201d, \u201cwe\u201d, \u201cus\u201d, or \u201cour\u201d).",
  "SYNAPHY is currently in its pre-launch phase. Our website is being used to introduce the SYNAPHY vision, collect early community interest, provide updates, and allow users to register their interest in the upcoming SYNAPHY ecosystem.",
  "This Pre-Launch Privacy Notice explains how we handle information collected through synaphy.com during this phase.",
];

const SECTIONS = [
  {
    title: "Information We May Collect",
    paragraphs: ["When you voluntarily interact with our website or registration forms, we may collect:"],
    list: [
      "Name",
      "Email address",
      "Mobile number",
      "Country/city",
      "Referral or invitation information",
      "Information you voluntarily provide through forms",
      "Basic website/device information such as browser type, IP address and pages visited",
    ],
  },
  {
    title: "Why We Collect This Information",
    paragraphs: ["We may use this information to:"],
    list: [
      "Create and manage our pre-launch community",
      "Contact you regarding SYNAPHY updates",
      "Send Founding/pre-launch announcements",
      "Understand community interest",
      "Provide invitations or access to upcoming programs",
      "Improve our website and pre-launch experience",
      "Prevent spam, fraud or abuse",
      "Comply with applicable legal requirements",
    ],
  },
  {
    title: "No Physical-World Data Collection Yet",
    paragraphs: [
      "During the current pre-launch phase, SYNAPHY does not require contributors to submit road, vehicle, tyre, building, sensor or other physical-world data through the website.",
      "Any future collection of such information through SYNAPHY applications or contributor programs will be governed by updated privacy terms and applicable consent/permissions.",
    ],
  },
  {
    title: "Future SYNAPHY Products",
    paragraphs: [
      "SYNAPHY may introduce applications and services involving technologies such as:",
      "Before these features become operational, we expect to publish updated terms and privacy notices explaining the relevant data practices.",
    ],
    list: [
      "Computer vision",
      "AI",
      "Location information",
      "Camera/image data",
      "Physical-world observations",
      "Contributor networks",
      "Consumer applications",
    ],
  },
  {
    title: "Communications",
    paragraphs: [
      "If you provide your email address or mobile number, we may contact you regarding:",
      "You may request to stop receiving promotional communications at any time.",
    ],
    list: [
      "SYNAPHY launch updates",
      "Founding announcements",
      "Product releases",
      "Community activities",
      "Events or important service information",
    ],
  },
  {
    title: "Third-Party Services",
    paragraphs: [
      "Our website may use third-party services for hosting, analytics, communications, forms or other technical functions.",
      "Those providers may process limited information as necessary to provide their services and may have their own privacy policies.",
    ],
  },
  {
    title: "Data Security",
    paragraphs: [
      "We use reasonable measures to protect information collected through our website.",
      "However, no online system can be guaranteed to be completely secure.",
    ],
  },
  {
    title: "Data Retention",
    paragraphs: [
      "We retain pre-launch information only for as long as reasonably necessary for the purposes described above, legitimate business purposes, or applicable legal requirements.",
    ],
  },
  {
    title: "Your Requests",
    paragraphs: ["If you want to:", "you can contact us."],
    list: [
      "Correct your information",
      "Remove your information from our pre-launch database",
      "Stop receiving communications",
      "Ask how your information is being used",
    ],
  },
  {
    title: "Contact",
    list: [
      "SYNAPHY",
      "Website: synaphy.com",
      "Privacy Email: privacy@synaphy.com",
      "Registered/Operating Entity: Delaware, US",
    ],
  },
  {
    title: "Updates",
    paragraphs: [
      "As SYNAPHY moves from Pre-Launch \u2192 Founding \u2192 Pilot \u2192 Consumer Product, this notice may be replaced or supplemented with more detailed privacy policies appropriate to the features being introduced.",
      "This page represents the privacy practices applicable to the current pre-launch website and should not be treated as the complete privacy policy for future SYNAPHY applications or network functionality.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      title="Pre-Launch Privacy Notice"
      intro={INTRO}
      sections={SECTIONS}
    />
  );
}
